var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesTeam(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sales-team",
    transform: "translate(0.078 0.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(-0.078 -0.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2624",
    "data-name": "Path 2624",
    d: "M120.922,60.468A60.251,60.251,0,0,1,106.234,100h0c-.391.446-.782.887-1.178,1.324a60.445,60.445,0,0,1-5.148,4.988h0c-.607.5-1.228,1.038-1.855,1.534a60.218,60.218,0,0,1-16.382,9.285q-2.376.9-4.842,1.584a60.449,60.449,0,0,1-16.377,2.246H59.243l-1.078-.035h0a60.253,60.253,0,0,1-22.247-5.134c-.632-.281-1.253-.572-1.875-.877h0a60.5,60.5,0,1,1,86.878-54.446Z",
    transform: "translate(0.078 0.039)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2625",
    "data-name": "Path 2625",
    d: "M113.919,32.2C19.03-3.242,4.217,82.8,4.217,82.8h0a60.494,60.494,0,0,1,109.7-50.6Z",
    transform: "translate(0.057 0.026)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2626",
    "data-name": "Path 2626",
    d: "M79.05,117.33s-.662,12.541-8.433,10.173a5.184,5.184,0,0,1-1.074-5.473C71.229,118.118,77.1,118.138,79.05,117.33Z",
    transform: "translate(-34.447 -58.49)",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2627",
    "data-name": "Path 2627",
    d: "M52.429,136.546s2.167-1.3,1.706-4.871-4.119-6.2-4.119-6.2a9.306,9.306,0,0,0-2.2,7.575C48.546,137.58,52.429,136.546,52.429,136.546Z",
    transform: "translate(-23.754 -62.555)",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2628",
    "data-name": "Path 2628",
    d: "M83.048,149.3s-.326,8.724-7.555,6.276a4.64,4.64,0,0,1,.858-4.42C78.363,148.673,83.048,149.3,83.048,149.3Z",
    transform: "translate(-37.499 -74.396)",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2629",
    "data-name": "Path 2629",
    d: "M42.017,157a6.963,6.963,0,0,0-.757-6.14c-1.836-3.01-6.451-4.515-6.451-4.515s-2.147,5.373,1.154,9.336C38.41,158.6,42.017,157,42.017,157Z",
    transform: "translate(-16.965 -72.958)",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2630",
    "data-name": "Path 2630",
    d: "M61.447,152.633a44.416,44.416,0,0,1,2.177-17.427,34.519,34.519,0,0,1,3.8-7.941l1.259-1.831,1.4-1.706c.241-.281.462-.577.712-.848l.783-.773,1.575-1.545a.361.361,0,1,1,.5.5l-.03.025-1.5,1.535-.757.768c-.241.266-.451.557-.677.833l-1.344,1.686-1.194,1.816a33.685,33.685,0,0,0-3.6,7.791,43.362,43.362,0,0,0-1.886,16.966v.04a.617.617,0,0,1-1.229.12Z",
    transform: "translate(-30.546 -60.034)",
    fill: "#7ca53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2631",
    "data-name": "Path 2631",
    d: "M58.065,143.158a13.837,13.837,0,0,1-2.769-3.105,20.267,20.267,0,0,1-1.906-3.637,23.579,23.579,0,0,1-1.124-3.933c-.156-.662-.206-1.344-.316-2.007s-.1-1.354-.15-2.032a.286.286,0,0,1,.261-.306.281.281,0,0,1,.306.256v.025c.06.662.105,1.324.186,2.007a15.306,15.306,0,0,0,.336,1.956,23,23,0,0,0,1.159,3.792,19.439,19.439,0,0,0,1.891,3.461,13.094,13.094,0,0,0,2.619,2.854l.03.025a.431.431,0,0,1,.075.6.421.421,0,0,1-.6.075Z",
    transform: "translate(-25.795 -63.882)",
    fill: "#7ca53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2632",
    "data-name": "Path 2632",
    d: "M75.885,151.5a26.937,26.937,0,0,1-2.759,2.644A24.364,24.364,0,0,1,70,156.349a22.751,22.751,0,0,1-3.446,1.671,17.427,17.427,0,0,1-3.727,1,.414.414,0,0,1-.125-.818h.035a17.127,17.127,0,0,0,3.547-.928,22.759,22.759,0,0,0,3.361-1.575,23.145,23.145,0,0,0,3.065-2.087,27.154,27.154,0,0,0,2.729-2.533h0a.3.3,0,0,1,.426,0,.306.306,0,0,1,.02.416Z",
    transform: "translate(-31.059 -75.277)",
    fill: "#7ca53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2633",
    "data-name": "Path 2633",
    d: "M49.4,162.026a12.883,12.883,0,0,1-4.44-1.876,19.339,19.339,0,0,1-3.622-3.045,24.873,24.873,0,0,1-2.859-3.742c-.421-.657-.778-1.354-1.169-2.032l-1-2.117a.251.251,0,0,1,.115-.336.261.261,0,0,1,.336.115h0L37.8,151.05c.4.652.768,1.329,1.194,1.966a24.249,24.249,0,0,0,2.864,3.567,18.66,18.66,0,0,0,3.547,2.829,12.286,12.286,0,0,0,4.1,1.645h.055a.5.5,0,0,1-.161.953Z",
    transform: "translate(-18.055 -74.213)",
    fill: "#7ca53c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1449",
    "data-name": "Rectangle 1449",
    width: 28.599,
    height: 5.874,
    transform: "translate(16.96 91.548)",
    fill: "#c69c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2634",
    "data-name": "Path 2634",
    d: "M62.336,194.28l-.416,1.972L58.458,212.7h-4.45A60.424,60.424,0,0,1,37.8,202.116l-1.214-5.864-.416-1.972Z",
    transform: "translate(-18.003 -96.873)",
    fill: "#c69c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2635",
    "data-name": "Path 2635",
    d: "M36.556,196.251H61.9l.416-1.972H36.14Z",
    transform: "translate(-17.988 -96.873)",
    fill: "#af865d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1450",
    "data-name": "Rectangle 1450",
    width: 39.425,
    height: 26.467,
    rx: 8.76,
    transform: "translate(12.219 30.471)",
    fill: "#2992e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2636",
    "data-name": "Path 2636",
    d: "M66.646,60.75H39V77.631a4.394,4.394,0,0,0,4.394,4.394H71.061V65.139a4.394,4.394,0,0,0-4.415-4.389Z",
    transform: "translate(-19.416 -30.277)",
    fill: "#0a82cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2637",
    "data-name": "Path 2637",
    d: "M20.612,105.96l-3.692,9.792L32.015,108.7Z",
    transform: "translate(-8.393 -52.82)",
    fill: "#2992e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1451",
    "data-name": "Rectangle 1451",
    width: 39.425,
    height: 26.467,
    rx: 8.76,
    transform: "translate(22.714 22.045)",
    fill: "#10c5ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2638",
    "data-name": "Path 2638",
    d: "M112.5,89.15l3.692,9.792L101.1,91.889Z",
    transform: "translate(-50.386 -44.437)",
    fill: "#10c5ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2639",
    "data-name": "Path 2639",
    d: "M84.571,68.6a1.726,1.726,0,1,1-.5-1.223A1.726,1.726,0,0,1,84.571,68.6Z",
    transform: "translate(-40.417 -33.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_266",
    "data-name": "Ellipse 266",
    cx: 1.726,
    cy: 1.726,
    r: 1.726,
    transform: "translate(51.27 33.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 1.726,
    cy: 1.726,
    r: 1.726,
    transform: "translate(30.116 33.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2640",
    "data-name": "Path 2640",
    d: "M91.989,202.042V203.3c-.03,1.214-.1,2.378-.206,3.416h0a9.285,9.285,0,0,1-.913,3.687c-.6.923-3.762,2.619-7.961,4.57a59.8,59.8,0,0,1-13.043-4.088c-.632-.281-1.254-.572-1.876-.878,3.592-2.358,7.675-4.861,12.04-7.239-.236-1.395-.472-2.859-.672-4.224a.251.251,0,0,0,0-.06c-.045-.286-.085-.567-.13-.843-.11-.752-.211-1.46-.3-2.082-.05-.351-.1-.677-.135-.968l-.03-.206a3.911,3.911,0,0,0-.07-.532c-.055-.406-.09-.692-.11-.823v-.045a.225.225,0,0,1,0-.04c2.323-.2,4.314-.452,5.985-.707a49.4,49.4,0,0,0,5.052-1c1.3-.326,1.921-.552,1.921-.552s.09,1.064.191,2.7c0,.231.025.477.04.732.045.813.09,1.736.13,2.719C91.964,198.491,92,200.292,91.989,202.042Z",
    transform: "translate(-33.874 -95.079)",
    fill: "#feb099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2641",
    "data-name": "Path 2641",
    d: "M89.11,192.977s.431,3.311,1,6.938c2.433-.241,8.3-.351,12.386,3.406.15-5.729-.426-12.591-.426-12.591S98.085,192.2,89.11,192.977Z",
    transform: "translate(-44.405 -95.104)",
    fill: "#f6896a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2642",
    "data-name": "Path 2642",
    d: "M90.773,150s-5.518,6.105-5.613,27.089c8.026,1.209,17.021-.838,17.021-.838S101.489,154.56,90.773,150Z",
    transform: "translate(-42.436 -74.791)",
    fill: "#100484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2643",
    "data-name": "Path 2643",
    d: "M101.005,159.31c0,4.67-.592,15.466-6.215,22.79a57.972,57.972,0,0,0,12.19-1.209S106.539,167.236,101.005,159.31Z",
    transform: "translate(-47.238 -79.432)",
    fill: "#150958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2644",
    "data-name": "Path 2644",
    d: "M92.285,197.115c-3.512,0-6.18-.246-6.231-.251a.363.363,0,1,1,.07-.722c.1,0,9.531.868,16.018-.672a.366.366,0,0,1,.441.271.361.361,0,0,1-.271.436A45.936,45.936,0,0,1,92.285,197.115Z",
    transform: "translate(-42.719 -97.461)",
    fill: "#150958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2645",
    "data-name": "Path 2645",
    d: "M138.687,35.794s7.66-7.023,16.218-.572.948,33.836,17.558,32.106c-10.715,23.934-30.41,7.886-35-1.555C128.809,47.974,138.687,35.794,138.687,35.794Z",
    transform: "translate(-66.784 -16.174)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2646",
    "data-name": "Path 2646",
    d: "M148.015,169.661c-.607.5-1.229,1.038-1.856,1.535a60.263,60.263,0,0,1-16.374,9.281q-2.378.9-4.846,1.585a60.5,60.5,0,0,1-16.389,2.247h-1.209l-1.079-.035v-1.279c-.03-2.563-.135-5.257-.341-8.026h0c-.09-1.279-.2-2.573-.341-3.888-.2-1.9-.436-3.823-.742-5.764h0q-.206-1.339-.451-2.694c-.04-.236-.085-.472-.13-.712h0c-.145-.793-.306-1.59-.5-2.388a89.965,89.965,0,0,0-2.428-9.135A73.064,73.064,0,0,0,96.35,138.5a56.8,56.8,0,0,1,14.473-9.973l16.5-1.6a105.8,105.8,0,0,1,19.916,6.361,155.887,155.887,0,0,0-.256,24.466h0c0,.336.035.667.06,1l.045.737c.025.331.05.657.07,1l.15,1.941c.06.717.12,1.435.191,2.147v.075a1.874,1.874,0,0,0,.04.472v.085l.105,1.109.03.306v.206l.03.326c.03.261.055.5.08.778a.172.172,0,0,1,0,.05l.09.823a.927.927,0,0,0,.035.311A1.962,1.962,0,0,1,148.015,169.661Z",
    transform: "translate(-48.038 -63.309)",
    fill: "#100484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2647",
    "data-name": "Path 2647",
    d: "M117.169,239.984l-1.079-.035h0V238.67C116.366,239.046,116.727,239.493,117.169,239.984Z",
    transform: "translate(-57.857 -118.994)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2648",
    "data-name": "Path 2648",
    d: "M181.235,199.278h0c-.607.5-1.229,1.038-1.856,1.535A60.263,60.263,0,0,1,163,210.1c1.079-1.2,2.107-2.463,3.08-3.742a93.032,93.032,0,0,0,8.5-13.725V192.6c.346-.677.662-1.314.948-1.906l.562-1.169c.12-.266.241-.5.351-.757.682-1.5,1.043-2.393,1.043-2.393l2.709,1h0c0,.336.04.667.065,1,0,.251.03.5.05.737,0,.331.04.662.07,1,.045.647.1,1.3.145,1.941.06.722.12,1.435.186,2.147v.075l.045.472v.085l.105,1.109.03.306v.206l.03.326.03.261a4.991,4.991,0,0,0,.05.5.171.171,0,0,1,0,.05l.06.5.03.3a.927.927,0,0,0,.035.311Z",
    transform: "translate(-81.262 -92.931)",
    fill: "#150958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2649",
    "data-name": "Path 2649",
    d: "M197.506,207.645h0c-.607.5-1.229,1.038-1.856,1.535.6-2.107,1.058-4.134,1.4-6.02l.105,1.109.03.306v.206l.06.587c.035.361.075.727.115,1.089l.03.3a.928.928,0,0,0,.035.311Z",
    transform: "translate(-97.551 -101.298)",
    fill: "#3235cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2650",
    "data-name": "Path 2650",
    d: "M138.086,104.16a65.253,65.253,0,0,0,2.333,11.408c-4.645,5.017-12.787,6.9-16.5,1.6-.085-4.881-1.294-13.008-1.294-13.008S128.449,108.294,138.086,104.16Z",
    transform: "translate(-61.121 -51.925)",
    fill: "#feb099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2651",
    "data-name": "Path 2651",
    d: "M142.109,110.125a51.427,51.427,0,0,1-1-5.965,18.928,18.928,0,0,1-11.734,1.46l-.642,3.853S134.088,114.554,142.109,110.125Z",
    transform: "translate(-64.166 -51.922)",
    fill: "#f6896a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M108.969,72s-7.2-.085-4.093,8.669,7.374,5.644,7.374,5.644S112.541,78.521,108.969,72Z",
    transform: "translate(-51.878 -35.886)",
    fill: "#f43b51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    "data-name": "Path 2653",
    d: "M110.5,61.809a20.482,20.482,0,0,1-1.911-10.158c.5-5.443,10.775-16.62,21.571-9.446s10.449,27.059.9,29.919C127.137,60.2,110.5,61.809,110.5,61.809Z",
    transform: "translate(-54.105 -19.868)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    d: "M124.756,83.611c5.358-.778,11.443-7.73,10.49-18.36-1.189-13.294-9.938-15.3-14.688-14.081s-11.232,7.861-7.776,18.661S119.509,84.374,124.756,83.611Z",
    transform: "translate(-55.73 -25.351)",
    fill: "#feb099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M111.291,63.447s7.264,1.806,13.831-7.439c.953,6.05,4.58,8.553,9.592,8.207,1.47-8.026-3.371-14.859-10.8-15.381C114.688,48.2,108.863,56.118,111.291,63.447Z",
    transform: "translate(-55.198 -24.316)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M137.454,53.246S132.372,38.162,118,43.65c.286-1,5.729-6.612,14.693-3.266,8.588,3.206,8.939,12.862,8.939,12.862Z",
    transform: "translate(-58.819 -19.594)",
    fill: "#f43b51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M156.172,63.53s-4.144.176-5.814,2.132-1.9,6.451-1.5,8.814,2.634,7.57,7.856,5.689A42.847,42.847,0,0,0,156.172,63.53Z",
    transform: "translate(-74.116 -31.663)",
    fill: "#f43b51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M142.7,98.967l-.3-.923a26.889,26.889,0,0,0,9.095-5.634l.682.692A27.659,27.659,0,0,1,142.7,98.967Z",
    transform: "translate(-70.982 -46.062)",
    fill: "#fe5665"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M159.18,63.489c4.806-.933,6.266,14.2.542,16.635S152.383,64.818,159.18,63.489Z",
    transform: "translate(-77.127 -31.622)",
    fill: "#fe5665"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_268",
    "data-name": "Ellipse 268",
    cx: 1.194,
    cy: 1.194,
    r: 1.194,
    transform: "translate(70.359 51.247)",
    fill: "#1a3a51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2660",
    "data-name": "Path 2660",
    d: "M182.767,195.139h0c-.391.446-.783.888-1.179,1.324a60.486,60.486,0,0,1-5.152,4.991h0c-.607.5-1.229,1.038-1.856,1.535a60.264,60.264,0,0,1-16.394,9.291q-2.378.9-4.846,1.585c2.308-1.64,4.981-3.461,7.926-5.328s6.261-3.853,9.722-5.729c-.236-1.38-.467-2.829-.667-4.179-.05-.311-.1-.617-.14-.918l-.03-.211c-.025-.181-.055-.361-.08-.537-.115-.808-.216-1.54-.306-2.152v-.035h0c-.05-.371-.1-.7-.13-.963a.646.646,0,0,0-.035-.266c-.05-.361-.075-.562-.075-.562l1.2-.105c1.846-.181,3.456-.386,4.846-.6h0a39.716,39.716,0,0,0,6.893-1.53s.045.557.11,1.5v.5c0,.105.025.356.035.542l.03.456C182.7,194.156,182.727,194.633,182.767,195.139Z",
    transform: "translate(-76.465 -95.114)",
    fill: "#feb099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2661",
    "data-name": "Path 2661",
    d: "M198.854,195.139h0c-.391.446-.783.888-1.179,1.324a25.5,25.5,0,0,0-5.613.436h0a27.089,27.089,0,0,0-5.644,1.726c-.05-.311-.1-.617-.14-.918l-.03-.211c-.025-.181-.055-.361-.08-.537-.115-.808-.216-1.54-.306-2.152v-.035h0c-.05-.371-.1-.7-.13-.963a.646.646,0,0,0-.035-.266c-.05-.361-.075-.562-.075-.562l1.194-.1c1.846-.181,3.456-.386,4.846-.6h0a39.715,39.715,0,0,0,6.893-1.53s.045.557.11,1.5v.5c0,.1.025.356.035.542l.03.456C198.788,194.156,198.813,194.633,198.854,195.139Z",
    transform: "translate(-92.552 -95.114)",
    fill: "#f6896a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2662",
    "data-name": "Path 2662",
    d: "M189.318,139.58s4.324,4.289,8.3,26.768c-6.827,3.216-16.218,2.955-16.218,2.955a87.294,87.294,0,0,1-.572-13.163C181.357,144.115,189.318,139.58,189.318,139.58Z",
    transform: "translate(-90.14 -69.596)",
    fill: "#100484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2663",
    "data-name": "Path 2663",
    d: "M180.809,174.485a.361.361,0,0,1-.351-.286c-.035-.15-3.191-15.12,2.9-24.787a.363.363,0,1,1,.612.391c-5.924,9.411-2.834,24.079-2.8,24.24a.361.361,0,0,1-.276.431Z",
    transform: "translate(-89.537 -74.413)",
    fill: "#150958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2664",
    "data-name": "Path 2664",
    d: "M181.306,189.684h-.752a.366.366,0,1,1,0-.727c.1,0,9.471.226,15.551-2.433a.371.371,0,0,1,.5.186.366.366,0,0,1-.191.5C191.134,189.488,183.694,189.684,181.306,189.684Z",
    transform: "translate(-89.824 -92.974)",
    fill: "#150958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2665",
    "data-name": "Path 2665",
    d: "M130.21,135.668c-6.627,0-8.794-4.279-8.884-4.47a.361.361,0,0,1,.166-.5.366.366,0,0,1,.5.171c.09.181,2.293,4.44,9.155,4.013a14.809,14.809,0,0,0,10.665-5.634.361.361,0,0,1,.5-.09.366.366,0,0,1,.1.5,15.31,15.31,0,0,1-11.237,5.98Q130.677,135.668,130.21,135.668Z",
    transform: "translate(-60.455 -64.355)",
    fill: "#150958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2666",
    "data-name": "Path 2666",
    d: "M159.674,166.431l-3.732.256a.211.211,0,0,1-.176-.351l1.339-1.54a1.5,1.5,0,0,1,2.127-.145l.8.7a.617.617,0,0,1-.361,1.079Z",
    transform: "translate(-77.618 -81.899)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    "data-name": "Path 2667",
    d: "M156.073,178.015l3.732-.256a.211.211,0,0,1,.176.351l-1.344,1.54a1.5,1.5,0,0,1-2.122.145l-.8-.7a.617.617,0,0,1,.361-1.079Z",
    transform: "translate(-77.514 -88.621)",
    fill: "#00adee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2668",
    "data-name": "Path 2668",
    d: "M155.469,173.641l6.356-.431c.276,0,.446.4.266.662l-.707,1.033a.286.286,0,0,1-.211.13l-4.811.326a.3.3,0,0,1-.231-.1l-.838-.928C155.093,174.108,155.189,173.661,155.469,173.641Z",
    transform: "translate(-77.358 -86.353)",
    fill: "#00adee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2669",
    "data-name": "Path 2669",
    d: "M150.987,170.83l.737-1.038a.321.321,0,0,1,.231-.13l5.017-.341a.3.3,0,0,1,.241.1l.873.923c.226.236.105.672-.186.692l-6.637.456C150.952,171.512,150.8,171.09,150.987,170.83Z",
    transform: "translate(-75.222 -84.413)",
    fill: "#00adee"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesTeam);
export default __webpack_public_path__ + "static/media/sales-team.8123ce9a8fb06b8e7d0d1056cb272ca2.svg";
export { ForwardRef as ReactComponent };